import type { ISessionRepository, SessionOverlapCheckOptions, SessionOverlapEntity } from '../repositories/ISessionRepository.js';

interface Deps { sessionRepository: ISessionRepository; }

export function createCheckSessionAchieverOverlapUseCase({ sessionRepository }: Deps) {
  return async function checkSessionAchieverOverlap(input: SessionOverlapCheckOptions): Promise<SessionOverlapEntity[]> {
    return sessionRepository.checkAchieverOverlap(input);
  };
}
